module.exports = __webpack_public_path__ + "img/llma.a8ac4596.svg";